import { Link } from 'react-router-dom';
import { categories, articles, featuredArticles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';
import { useEffect } from 'react';

const heroBgUrl = "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20literature%20scroll%20unfurling%20dramatically%20with%20warm%20golden%20light%20ink%20wash%20artistic%20style%20ethereal%20atmosphere%20cinematic%20composition%20deep%20shadows%20and%20highlights%20classical%20elegance%20museum%20quality%20artistic%20photography&width=1800&height=1000&seq=home-hero-bg&orientation=landscape";

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const latestArticles = articles
    .filter((a) => !a.featured)
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());

  return (
    <main>
      {/* Schema.org WebPage */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "玉蒲团之偷情宝鉴 - 经典情色文学赏析与文化解读",
        "description": "深度赏析华语经典情色文学与电影改编，探讨玉蒲团之偷情宝鉴的叙事结构、艺术价值与文化影响力。",
        "url": "https://ibfdxic.cn/",
        "inLanguage": "zh-Hans",
        "isPartOf": {
          "@type": "WebSite",
          "name": "玉蒲团文化研究中心",
          "url": "https://ibfdxic.cn"
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": "https://ibfdxic.cn/"
          }]
        }
      }) }} />

      {/* Hero Section */}
      <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
        <img
          src={heroBgUrl}
          alt="玉蒲团文化研究 - 经典情色文学赏析"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

        {/* Decorative elements */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-10 w-64 h-64 rounded-full bg-primary-500/30 blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 rounded-full bg-accent-500/20 blur-3xl"></div>
        </div>

        <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-50/90 text-xs font-medium mb-6">
            <i className="ri-sparkling-line"></i>
            华语经典情色文化深度研究平台
          </div>
          <h1 className="font-heading font-black text-3xl md:text-5xl lg:text-6xl text-background-50 mb-6 leading-tight tracking-tight">
            玉蒲团之偷情宝鉴
            <span className="block text-xl md:text-2xl lg:text-3xl font-semibold mt-2 text-background-50/80">
              经典情色文学赏析与文化解读
            </span>
          </h1>
          <p className="text-background-50/70 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
            围绕「玉蒲团之偷情宝鉴」展开深度赏析，探讨其作为华语经典情色文学与电影改编的
            历史地位、艺术价值与文化背景，帮助读者全面了解这部作品的叙事结构、时代意义及
            其在华语影坛的影响力。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/wenxue-shangxi"
              className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-book-open-line mr-2"></i>
              开始阅读
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-information-line mr-2"></i>
              了解我们
            </Link>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
          <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
        </div>
      </section>

      {/* Category Navigation */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              探索分类
            </h2>
            <p className="text-foreground-500 text-sm max-w-lg mx-auto">
              按主题分类浏览，找到您感兴趣的研究方向
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center text-center p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-foreground-400 text-xs leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Articles */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-10">
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-2">
                精选推荐
              </h2>
              <p className="text-foreground-500 text-sm">
                编辑团队精心挑选的深度好文
              </p>
            </div>
            <Link
              to="/category/wenxue-shangxi"
              className="hidden sm:flex items-center gap-1 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {featuredArticles.map((article) => (
              <ArticleCard
                key={article.id}
                title={article.title}
                slug={article.slug}
                excerpt={article.excerpt}
                imageUrl={article.imageUrl}
                author={article.author}
                publishDate={article.publishDate}
                readTime={article.readTime}
                categoryName={categories.find((c) => c.id === article.category)?.name}
                variant="featured"
              />
            ))}
          </div>
        </div>
      </section>

      {/* Latest Articles */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-10">
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-2">
                最新文章
              </h2>
              <p className="text-foreground-500 text-sm">
                持续更新的学术研究与文化解读
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {latestArticles.map((article) => (
              <ArticleCard
                key={article.id}
                title={article.title}
                slug={article.slug}
                excerpt={article.excerpt}
                imageUrl={article.imageUrl}
                author={article.author}
                publishDate={article.publishDate}
                readTime={article.readTime}
                categoryName={categories.find((c) => c.id === article.category)?.name}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter / CTA */}
      <section className="py-14 md:py-20 bg-background-900">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-4">
            加入我们的文化探索之旅
          </h2>
          <p className="text-background-300 text-sm md:text-base max-w-lg mx-auto mb-8 leading-relaxed">
            订阅我们的学术通讯，获取最新的华语情色文学与电影研究动态，深入探索经典作品背后的文化密码。
          </p>
          <Link
            to="/about"
            className="inline-flex items-center px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-mail-send-line mr-2"></i>
            联系我们
          </Link>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-10 text-center">
            常见问题
          </h2>

          {/* Schema.org FAQPage */}
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "《玉蒲团》是一部什么样的作品？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "《玉蒲团》又名《觉后禅》，是明清之际流传甚广的情色小说代表作。作品在情欲描写之外，构建了完整的叙事框架与哲学思辨体系，具有重要的文学研究价值。"
                }
              },
              {
                "@type": "Question",
                "name": "《玉蒲团之偷情宝鉴》是哪一年上映的？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "《玉蒲团之偷情宝鉴》于1991年上映，由麦当杰执导，是香港三级片黄金时代的里程碑之作，在商业和艺术上都取得了显著成就。"
                }
              },
              {
                "@type": "Question",
                "name": "本网站的研究内容主要涉及哪些方面？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "本网站围绕文学赏析、电影评析、文化背景、影坛影响、三级片文化史和成人电影历史六大维度，提供专业的学术研究与文化解读内容。"
                }
              },
              {
                "@type": "Question",
                "name": "如何参与本网站的学术讨论？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "您可以通过「关于我们」页面的联系方式与我们取得联系，或订阅我们的学术通讯，获取最新研究动态并参与讨论。"
                }
              }
            ]
          }) }} />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { q: "《玉蒲团》是一部什么样的作品？", a: "《玉蒲团》又名《觉后禅》，是明清之际流传甚广的情色小说代表作。作品在情欲描写之外，构建了完整的叙事框架与哲学思辨体系，具有重要的文学研究价值。" },
              { q: "《玉蒲团之偷情宝鉴》是哪一年上映的？", a: "《玉蒲团之偷情宝鉴》于1991年上映，由麦当杰执导，是香港三级片黄金时代的里程碑之作，在商业和艺术上都取得了显著成就。" },
              { q: "本网站的研究内容主要涉及哪些方面？", a: "本网站围绕文学赏析、电影评析、文化背景、影坛影响、三级片文化史和成人电影历史六大维度，提供专业的学术研究与文化解读内容。" },
              { q: "如何参与本网站的学术讨论？", a: "您可以通过「关于我们」页面的联系方式与我们取得联系，或订阅我们的学术通讯，获取最新研究动态并参与讨论。" },
            ].map((faq, i) => (
              <div key={i} className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-2">
                  {faq.q}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed">
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}